import { FormHelperText, Grid, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { Controller } from 'react-hook-form';

const DAY_FORMAT = 'YYYY-MM-DD';

const DateInputController = ({
  control,
  name,
  error,
  label,
  setValue,
  clearErrors,
}) => {
  return (
    <Grid item xs={12} sm={6}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <DatePicker
              {...field}
              className={clsx('full-width', 'date-picker', {
                'Mui-error': !!error,
              })}
              onChange={(val) => {
                setValue(name, val.format(DAY_FORMAT));
                clearErrors(name);
              }}
              value={field.value ? dayjs(field.value, DAY_FORMAT) : null}
              label={label}
              renderInput={(params) => (
                <TextField {...params} variant="outlined" />
              )}
            />
          )}
        />
      </LocalizationProvider>
      {!!error && (
        <FormHelperText marginLeft="14px" error>
          {error.message}
        </FormHelperText>
      )}
    </Grid>
  );
};

export default DateInputController;
